<template>

    <div class="register__form-group" :class="{'register__form-group_type_is-invalid': isInvalid}">

        <input
            :id="inputId"
            :type="type"
            :name="name"
            v-model="inputValue"
            ref="formInput"
            class="j-register__input register__input form-control"
            :class="{'register__input_type_active': isInput, [`${inputClass}`]: inputClass}"
            @click="formInputClick"
            @input="formInputChange"
            @blur="formInputBlur"

        />

        <label
            class="register__label control-label"
            :class="{'register__label_type_active': isLabel}"
            :for="inputId"
        >
            {{ gettext(label) }}
        </label>

        <div
            class="register__clear-input"
            :class="{'register__clear-input_type_active': isClear}"
            @click="formClearInputClick"
        >
            <i class="fi fi-times"></i>
        </div>
    </div>
</template>

<script>
    export default {
        name: "form-input",

        props : {
            type: {
                type: String,
            },
            name: {
                type: String,
            },
            value: {
                type: String,
            },
            label: {
                type: String,
            },
            inputId: {
                type: String,
            },
            inputClass: {
                type: String,
            },
            required: {
                type: String,
            }
        },

        data() {
            return {
                inputValue: '',

                isLabel: false,
                isInput: false,
                isClear: false,
            }
        },

        methods: {

            formInputClick() {
                this.isLabel = true;
                this.isInput = true;
            },

            formClearInputClick() {
                this.isLabel = false;
                this.isInput = false;
                this.isClear = false;
                this.inputValue = '';
            },

            formInputBlur() {
                if(!this.inputValue.trim().length) {
                    this.formClearInputClick();
                }
            },

            formInputChange() {
                this.inputValue.trim() && this.formIsActive()
            },

            formIsActive() {
                this.isLabel = true;
                this.isInput = true;
                this.isClear = true;
            },

            formFindInputAutofill() {
                const inputAutofill = this.$el.querySelector(':-webkit-autofill');
                !!inputAutofill && this.formIsActive();
            }

        },

        computed: {
            isInvalid() {
                return this.required.trim().length
            }
        },

        mounted() {
            this.inputValue = typeof this.inputValue !== 'undefined'
                ? ''
                : this.value;

            if(this.inputValue) {
                this.formIsActive()
            } else {
                window.addEventListener('load', this.formFindInputAutofill)
            }

        },

        destroyed() {
            window.removeEventListener('load', this.formFindInputAutofill)
        }
    }
</script>


<style scoped>

    .register__label {
        transform: translateY(0);
    }

    .register__label_type_active {
        transform: translateY(-25px);
    }

</style>